import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import "./styles.css";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
/*import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';*/
import axios from "axios";
import Select from "react-select";
import { MDBDataTable } from "mdbreact";
import "./styles.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
/*import Modal from '../../../../shared/components/Modal';*/
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import API from "../../../Common/api";

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

/*const data = {
    columns: [
      {
        label: 'Bin ID',
        field: 'bin_id',
        width: 150
      },
      {
        label: 'Storage Type',
        field: 'storage_type',
        width: 270
      },
      
      {
        label: 'Aisle',
        field: 'aisle',
        width: 100
      },
      {
        label: 'Rack',
        field: 'rack',
        width: 270
      },
      
      {
        label: 'Rack Type',
        field: 'rack_type',
        width: 270
      },
      {
        label: 'Level',
        field: 'level',
        width: 270
      },
      {
        label: 'Zone Name',
        field: 'zone_name',
        width: 270
      },
      {
        label: 'Zone No.',
        field: 'zone_number',
        width: 270
      }
      
    ],
    rows: [
      {
        name: 'Tiger Nixon',
        position: 'System Architect',
        office: 'Edinburgh',
        office: 'Edinburgh',
        office: 'Edinburgh',
        office: 'Edinburgh',
        office: 'Edinburgh',
        office: 'Edinburgh'
        
      },
      
      
      
      
      
      {
        bin_id: 'Donna Snider',
        position: 'Customer Support',
        office: 'New York',
        office: 'New York',
        office: 'New York',
        level: '',
        zone_name: 'ABCD',
        zone_number: 'Abc',
      }
    ]
  }
*/

var url = window.location.hostname;
var port = window.location.port;

const options = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" },
];

function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.change = this.change.bind(this);
    this.fetchBinData = this.fetchBinData.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleFailed = this.toggleFailed.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.Successtoggle = this.Successtoggle.bind(this);
    this.SuccesstoggleCancel = this.SuccesstoggleCancel.bind(this);
    this.handleChangeValues = this.handleChangeValues.bind(this);
    this.handleChangeFrom = this.handleChangeFrom.bind(this);
    this.fetchReason = this.fetchReason.bind(this);
    this.showTypeahead1 = this.showTypeahead1.bind(this);
    this.showTypeahead = this.showTypeahead.bind(this);
    this.showTypeahead2 = this.showTypeahead2.bind(this);
    this.handleChangeValuesReason = this.handleChangeValuesReason.bind(this);
    this.fetchStockData = this.fetchStockData.bind(this);
    this.setBinId = this.setBinId.bind(this);
    this.closeContainer = this.closeContainer.bind(this);
    this.ShowotherKey = this.ShowotherKey.bind(this);

    this.accessCookie = this.accessCookie.bind(this);
    /*this.onMasterChange = this.onMasterChange.bind(this);*/

    this.state = {
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      showInvalidBaseItem: false,
      showInvalidProductItem: false,
      showToZone: false,
      showResponseData: false,
      showBaseResponseData: false,
      showProductResponseData: false,
      responseUpdatedBaseData: false,
      responseUpdatedProductData: false,
      showToZone: false,
      showRowDataError: false,
      showBinAddress: false,
      showSubmitBtn: false,
      invalidItemList: [],
      selectedOption: null,
      value: "0",
      FromValue: "0",
      posts: [],
      postsBase: [],
      postsProduct: [],
      tableRowsBase: [],
      tableRowsProduct: [],
      arr_data_val: [],
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      Successmodal: false,
      loading: false,
      showQuantity: false,
      Reasonvalue: "0",

      showProductLedgerFilter: false,
      ledger_lbskuid: "",
      ledger_fromdate: "",
      ledger_todate: "",
      ledger_cbucode: "",

      isLoading: true,
      showFetchBinData: false,
      showFetchBaseData: false,
      showFetchProductData: false,
      showReason: false,
      showRemarks: false,
      show_process_data: true,
      showHistoryData: false,

      tableRows: [],
      value: "",
      error: "",
      value: "select",
      selectedFileType: "",
      BinMasters: [
        "Aisle",
        "Bin",
        "Bin Address",
        "Level",
        "Rack",
        "Rack Type",
        "Storage Type",
        "Zone Name",
        "Zone No.",
      ],
      /*BasePackCodes:["Base Pack Code" , "Zone Name" , "Zone No"],*/

      BasePackCodes: [
        { "Base Pack Code": "fghj", "Zone Name": "fghj", "Zone No": "fghj" },
      ],

      validation: {
        "Bin Master": {
          Aisle: "string",
          Bin: "number",
          "Bin Address": "string",
          Level: "number",
          Rack: "number",
          "Rack type": "string",
          "Storage type": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },

        "Basepack Zone": {
          "Base Pack Code": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },

        "Product Master": {
          Company: "string",
          Brand: "number",
          "Sub Brand": "string",
          "LB SKU ID": "number",
          "LB SKU Product Name": "number",
          "Basepack Code": "string",
          "CBU Code": "string",
          "Shade Code": "string",
          "Shade Name": "number",
          Category: "string",
          "Sub-Category": "string",
          "Price Lot": "string",
          MRP: "string",
          UOM: "string",
          UPC: "string",
          "Pack Size": "string",
          "Pack Size UOM": "string",
          EAN: "string",
          "ICLD EAN": "string",
          Weight: "string",
          Volume: "string",
          "ICLD Volume": "string",
          "SKU7 Code": "string",
          "SKU5 Code": "string",
          Offer: "string",
          Tester: "string",
          "Storage Type": "string",
          Status: "string",
          "Created Date Time": "string",
          "Updated Date Time": "string",
        },
      },
    };
  }

  setBinId(item, BinId) {
    console.log(item);
    console.log(BinId);
    this.setState({
      typeaheadText1: item,
      BinId: BinId,
      showQuantity: true,
      typeaheadText: "",
    });

    console.log(this.state.BinId);
  }

  ledgerLbskuIDChange = (e) => {
    if (e.target.name == "ledger_binaddress") {
      this.setState({
        ledger_binaddress: e.target.value,
      });
    }

    if (e.target.name == "ledger_lbskuid") {
      this.setState({
        ledger_lbskuid: e.target.value,
      });
    }

    if (e.target.name == "ledger_cbucode") {
      this.setState({
        ledger_cbucode: e.target.value,
      });
    }
  };

  ledgerFromDateChange = (date) => {
    this.setState({
      ledger_fromdate: date,
    });
  };

  ledgerToDateChange = (date) => {
    this.setState({
      ledger_todate: date,
    });
  };

  componentWillMount() {
    if (window.location.port == 8091) {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8090";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: Location,
    });

    localStorage.setItem("userName", username);
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  hideTypeahead = (e) => {
    if (this.state.showTypeahead1) {
      if (!this.typeahead.contains(e.target)) {
        this.setState({ showTypeahead1: false });
      }
    }
  };

  closeContainer() {
    this.setState({
      showTypeahead1: false,
    });
  }

  handleSearchClick = () => {
    if (
      (this.state.ledger_binaddress === "" ||
        this.state.ledger_binaddress === undefined) &&
      (this.state.ledger_lbskuid === "" ||
        this.state.ledger_lbskuid === undefined) &&
      (this.state.ledger_cbucode === "" ||
        this.state.ledger_cbucode === undefined)
    ) {
      alert("Select BIN ADDRESS or LBSKUID or CBU Code filter");
      return false;
    }

    var ledger_fromdate = "";
    var ledger_todate = "";
    if (
      this.state.ledger_fromdate != "" &&
      this.state.ledger_fromdate != undefined
    ) {
      ledger_fromdate = formatDate(this.state.ledger_fromdate);
    }
    if (
      this.state.ledger_todate != "" &&
      this.state.ledger_todate != undefined
    ) {
      ledger_todate = formatDate(this.state.ledger_todate);
    }

    const payload = {
      ocation: this.state.selectedLocation,
      bin_address: this.state.ledger_binaddress,
      lb_sku_id: this.state.ledger_lbskuid,
      cbu_code: this.state.ledger_cbucode,
      from_date: ledger_fromdate,
      to_date: ledger_todate,
    };

    API.post("/stock/fetchProductHist/v1/", { param: payload })
      .then((response) => response.data)

      .then((data) => {
        // console.log(data);

        // if (err) throw err;

        this.setState({ postsProduct: data });
        console.log(this.state.postsProduct);
      })

      .then(async () => {
        this.setState({
          tableRowsProduct: this.assemblePostsProduct(),
          isLoading: false,
          genloading: false,
          showHistoryData: true,
        });

        console.log(this.state.tableRowsProduct);
      });
  };
  /* componentDidMount() {
       axios
    .post(('http://'+url+'/stock/fetchProductHist/v1/' , 

            {
                    
              location: this.state.selectedLocation,
            
            },

           {
             headers: {
                  'Content-Type': 'application/json',
                  'Authorization' : this.state.userName
                  
                } 

           }
           

      )

      .then(response => response.data)

      .then(data => {

         // console.log(data);

         // if (err) throw err;

         this.setState({ postsProduct: data })
         console.log(this.state.postsProduct);

      })

      .then(async() => {

         this.setState({ tableRowsProduct:this.assemblePostsProduct(), isLoading:false, genloading: false })

         console.log(this.state.tableRowsProduct);

      });
  }*/

  showTypeahead1 = (e) => {
    const value = e.target.value;
    this.setState(
      {
        typeaheadText: value,
      },
      () => {
        /*const data_val = ["B-W-R-2" , "C-D-T-3" , "C-D-T-8" , "C-D-T-8"];*/
        this.setState({
          showTypeahead1: true,
          zwz_search_pannel: true,
          /*showQuantity: true,*/
          /* data: data_val*/
        });

        const payload = {
          location: this.state.selectedLocation,
          binAddress: value,
          lbSkuId: this.state.lbskuid_val,
        };

        API.post("/picking/getBins/v1/", { param: payload })
          .then((response) => {
            console.log(response);
            this.setState({
              data: response.data,
            });
            console.log(this.state.data);
          })
          .catch(function (error) {});
      }
    );
  };

  /*showTypeahead1 = (e) => {
    const value = e.target.value
    this.setState({
      typeaheadText1: value
    }, () => {
     
      this.setState({
        showTypeahead: true,
        zwz_search_pannel: true,
        showQuantity: true,
       
      })

     
    })
  }*/

  showTypeahead2 = (e) => {
    const value = e.target.value;
    this.setState(
      {
        typeaheadText2: value,
      },
      () => {
        /*const data_val = ["B-W-R-2" , "C-D-T-3" , "C-D-T-8" , "C-D-T-8"];*/
        this.setState({
          showTypeahead: true,
          zwz_search_pannel: true,

          /* data: data_val*/
        });
      }
    );
  };

  showTypeahead = (e) => {
    const value = e.target.value;
    this.setState(
      {
        typeaheadText: value,
      },
      () => {
        /*const data_val = ["B-W-R-2" , "C-D-T-3" , "C-D-T-8" , "C-D-T-8"];*/
        this.setState({
          showTypeahead: true,
          zwz_search_pannel: true,
          /*showReason: true*/

          /* data: data_val*/
        });
      }
    );
  };

  ShowotherKey = (e) => {
    if (e.key === "Enter") {
      this.setState({
        showTypeahead: true,
        zwz_search_pannel: true,
        showReason: true,
      });
    }
  };

  fetchStockData() {
    console.log(this.state.userName);

    const payload = {
      location: this.state.selectedLocation,
    };

    API.post("/stock/fetchSkuInventories/v1/", { param: payload })

      .then((response) => response.data)

      .then((data) => {
        // console.log(data);

        // if (err) throw err;

        this.setState({ postsProduct: data });
        console.log(this.state.postsProduct);
      })

      .then(async () => {
        this.setState({
          tableRowsProduct: this.assemblePostsProduct(),
          isLoading: false,
          genloading: false,
        });

        console.log(this.state.tableRowsProduct);
      });
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  /*onMasterChange(event){
    this.setState({
      value: event.target.value
    })
    console.log(this.state.value);

  }*/

  SuccesstoggleCancel() {
    this.setState({
      Successmodal: false,
    });
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  Successtoggle() {
    this.setState((prevState) => ({ Successmodal: !prevState.Successmodal }));
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

  togglePressCancel() {
    this.setState({
      modal: false,
    });
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  fetchBinData() {
    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
    });

    axios
      .get("http://" + url + "/inventory/bin_master/v1/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: this.state.userName,
        },
      })

      .then((response) => response.data)

      .then((data) => {
        // console.log(data);

        // if (err) throw err;

        this.setState({ posts: data });
      })

      .then(async () => {
        this.setState({ tableRows: this.assemblePosts(), isLoading: false });

        console.log(this.state.tableRows);
      });
  }

  fetchBaseData() {
    this.setState({
      showFetchBaseData: true,
      showFetchBinData: false,
      showFetchProductData: false,
    });

    axios
      .get("http://" + url + "/inventory/base_pack_zone_code_master/v1/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: this.state.userName,
        },
      })

      .then((response) => response.data)

      .then((data) => {
        // console.log(data);

        // if (err) throw err;

        this.setState({ postsBase: data });
      })

      .then(async () => {
        this.setState({
          tableRowsBase: this.assemblePostsBase(),
          isLoading: false,
        });

        console.log(this.state.tableRowsBase);
      });
  }

  fetchProductData() {
    this.setState({
      showFetchBaseData: false,
      showFetchBinData: false,
      showFetchProductData: true,
    });

    axios
      .get("http://" + url + "/product/product_master/v1/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: this.state.userName,
        },
      })

      .then((response) => response.data)

      .then((data) => {
        // console.log(data);

        // if (err) throw err;

        this.setState({ postsProduct: data });
        console.log(this.state.postsProduct);
      })

      .then(async () => {
        this.setState({
          tableRowsProduct: this.assemblePostsProduct(),
          isLoading: false,
        });

        console.log(this.state.tableRowsProduct);
      });
  }

  assemblePosts = () => {
    let posts = this.state.posts.map((post) => {
      return {
        bin_id: post.bin,

        storage_type: post.storageType,

        aisle: post.aisle,

        rack: post.rack,

        rack_type: post.rackType,

        level: post.level,

        bin: post.binAddress,

        zone_name: post.zoneName,

        zone_number: post.zoneNumber,
      };
    });

    return posts;
  };

  assemblePostsBase = () => {
    let postsBase = this.state.postsBase.map((post) => {
      return {
        base_pack_code: post.basePackCode,

        zone_name: post.zoneName,

        zone_number: post.zoneNo,
      };
    });

    return postsBase;
  };

  assemblePostsProduct = () => {
    console.log(this.state.postsProduct);

    let postsProduct = this.state.postsProduct.map((post) => {
      return {
        lb_sku_id: post.lb_sku_id,
        pkd: post.pkd,
        mrp: post.mrp,
        cbu_code: post.cbu_code,
        qty: post.qty,
        grn_id: post.grn_id,
        from_area: post.from_area,
        from_pre_move_count: post.from_pre_move_count,
        from_post_move_count: post.from_post_move_count,
        to_area: post.to_area,
        to_pre_move_count: post.to_pre_move_count,
        to_post_move_count: post.to_post_move_count,
        status: post.status,
        date: post.date,
        employee: post.employee,
        location: post.location,
        reason: post.reason_desc,
      };
    });
    this.setState({
      postsProduct: postsProduct,
    });

    return postsProduct;
  };

  btnClick(LBSKUID, LBSKUProductName, PKD, ID) {
    this.setState({
      modal: true,
      lbskuid_val: LBSKUID,
      product: LBSKUProductName,
      pkd_val: PKD,
      sku_id: ID,
      showToZone: false,
      showBinAddress: false,
      showQuantity: false,
      showRemarks: false,
      showReason: false,
      value: "0",
      showTypeahead1: "",
      showTypeahead: "",
      showTypeahead2: "",
      Reasonvalue: "0",
      FromValue: "0",
    });

    const payload = {
      location: this.state.selectedLocation,
      skuId: ID,
    };

    API.post("/stock/fetchSkuInventories/v1/", { param: payload })
      .then((response) => {
        this.fetchReason();

        var arr = [];

        // <---- Move declaration inside loop

        console.log("dfghjkl");

        if (response.data[0].damaged_leanbox > 0) {
          var orderData = {};
          orderData["label"] = "Damaged Leanbox";
          orderData["value"] = "damaged_leanbox";
          console.log("Damaged Leanbox");
        }
        if (response.data[0].damaged_primary > 0) {
          var orderData = {};
          orderData["label"] = "Damaged Primary";
          orderData["value"] = "damaged_primary";
          arr.push(orderData);
          console.log("Damaged Primary");
        }
        if (response.data[0].dispatch_staging > 0) {
          var orderData = {};
          orderData["label"] = "Dispatch Statging";
          orderData["value"] = "dispatch_staging";
          arr.push(orderData);
          console.log("Dispatch Statging");
        }
        if (response.data[0].z_damaged > 0) {
          var orderData = {};
          orderData["label"] = "Z Damaged";
          orderData["value"] = "z_damaged";
          arr.push(orderData);
          console.log("Z Damaged");
        }
        if (response.data[0].z_excess > 0) {
          var orderData = {};
          orderData["label"] = "Z Excess";
          orderData["value"] = "z_excess";
          arr.push(orderData);
        }
        if (response.data[0].z_expiry > 0) {
          var orderData = {};
          orderData["label"] = "Z Expiry";
          orderData["value"] = "z_expiry";
          arr.push(orderData);
        }
        if (response.data[0].z_minus > 0) {
          var orderData = {};
          orderData["label"] = "Z Minus";
          orderData["value"] = "z_minus";
          arr.push(orderData);
        }
        if (response.data[0].z_missing > 0) {
          var orderData = {};
          orderData["label"] = "Z Missing";
          orderData["value"] = "z_missing";
          arr.push(orderData);
        }
        if (response.data[0].z_plus > 0) {
          var orderData = {};
          orderData["label"] = "Z Plus";
          orderData["value"] = "z_plus";
          arr.push(orderData);
        }
        if (response.data[0].z_return > 0) {
          var orderData = {};
          orderData["label"] = "Z Return";
          orderData["value"] = "z_return";
          arr.push(orderData);
        }
        if (response.data[0].shortage_wh > 0) {
          var orderData = {};
          orderData["label"] = "Shortage Wh";
          orderData["value"] = "shortage_wh";
          arr.push(orderData);
        }
        if (response.data[0].shortage_returns > 0) {
          var orderData = {};
          orderData["label"] = "Shortage Returns";
          orderData["value"] = "shortage_returns";
          arr.push(orderData);
        }
        if (response.data[0].shortage_primary_pure > 0) {
          var orderData = {};
          orderData["label"] = "Shortage Primary Pure";
          orderData["value"] = "shortage_primary_pure";
          arr.push(orderData);
        }

        if (response.data[0].shortage_primary_interchange > 0) {
          var orderData = {};
          orderData["label"] = "Shortage Primary Interchange";
          orderData["value"] = "shortage_primary_interchange";
          arr.push(orderData);
        }

        if (response.data[0].excess_primary_interchange > 0) {
          var orderData = {};
          orderData["label"] = "Excess Primary Interchange";
          orderData["value"] = "excess_primary_interchange";
          arr.push(orderData);
        }

        if (response.data[0].excess_primary_pure > 0) {
          var orderData = {};
          orderData["label"] = "Excess Primary Pure";
          orderData["value"] = "excess_primary_pure";
          arr.push(orderData);
        }

        if (response.data[0].excess_returns > 0) {
          var orderData = {};
          orderData["label"] = "Excess Returns";
          orderData["value"] = "excess_returns";
          arr.push(orderData);
        }

        if (response.data[0].ptl_staging > 0) {
          var orderData = {};
          orderData["label"] = "PTL Statging";
          orderData["value"] = "ptl_staging";
          arr.push(orderData);
        }

        if (response.data[0].putaway_staging > 0) {
          var orderData = {};
          orderData["label"] = "PutAway Statging";
          orderData["value"] = "putaway_staging";
          arr.push(orderData);
        }

        console.log(arr);

        console.log(response);
        this.setState({
          stock_val: response.data[0].currentStockCount,
          schemas: response.data[0].zoneOptions,
          binData: response.data[0].binList,
          arr_data_val: arr,
        });
      })
      .catch(function (error) {});

    /*this.handleRemoveRow1();*/
  }

  fetchReason() {
    const payload = {
      location: this.state.selectedLocation,
    };

    API.post("/stock/fetchReasons/v1/", { param: payload })
      .then((response) => {
        console.log(response);
        this.setState({
          reason: response.data,
        });
      })
      .catch(function (error) {});
  }

  handleChangeValues(event) {
    this.setState({ value: event.target.data, ToValue: event.target.value });

    localStorage.setItem("ToDataVal", event.target.value);

    console.log(event.target.ToValue);

    if (event.target.value === "bin") {
      this.setState({
        showBinAddress: true,
        showQuantity: false,
      });
    } else {
      this.setState({
        showBinAddress: false,
        showQuantity: true,
      });
    }
  }

  handleChangeValuesReason(event) {
    this.setState({
      Reasonvalue: event.target.data,
      grnValues: event.target.value,
    });

    localStorage.setItem("ReasonValues", event.target.value);

    console.log(event.target.value);
    this.setState({
      showRemarks: true,
      showSubmitBtn: true,
    });

    /* if (event.target.value === "other") {
          this.setState({
            showRemarks: true,
            
          })

        } else{

          this.setState({
            showRemarks: false,
            
          })

        }*/
  }

  handleChangeFrom(event) {
    this.setState({
      FromValue: event.target.data,
      FromData: event.target.value,
    });

    localStorage.setItem("FromDataVal", event.target.value);
    if (event.target.value != "0") {
      this.setState({
        showToZone: true,
      });
    } else {
      this.setState({
        showToZone: false,
      });
    }
  }

  handleChange(evt) {
    const files = evt.target.files;
    if (files && files[0]) this.setState({ file: files[0] });
    var file1 = evt.target.value;
    var fileArray1 = evt.target.value.split(".");
    var extension1 = fileArray1[fileArray1.length - 1];
    if (extension1 != "xlsx" && extension1 != "csv" && extension1 != "xls") {
      $(".upload_error").css("display", "block");
      $(".upload_success").css("display", "none");
    } else {
      $(".upload_success").css("display", "block");
      $(".upload_error").css("display", "none");
      $(".button_enable").removeAttr("disabled", "disabled");
    }
  }

  change = (selectedOption) => {
    this.setState({
      selectedOption,
      selectedFileType: selectedOption.label,
      showInvalidProductItem: false,
      showRowDataErrorProduct: false,
      showInvalidBaseItem: false,
      showRowDataErrorBase: false,
      showRowDataError: false,
      showInvalidItem: false,
    });
    $(".upload_error").css("display", "none");
    $(".upload_success").css("display", "none");
    $(".fileControl").val("");

    if (selectedOption.value === "bin_master") {
      this.fetchBinData();
      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
      });
    } else if (selectedOption.value === "base_pack_zone") {
      this.fetchBaseData();
      this.setState({
        showFetchBinData: false,
        showFetchBaseData: true,
        showFetchProductData: false,
      });
    } else if (selectedOption.value === "product_master") {
      this.fetchProductData();
      this.setState({
        showFetchBinData: false,
        showFetchBaseData: false,
        showFetchProductData: true,
      });
    }

    console.log(`Option selected:`, selectedOption.value);
  };

  validateItem = (item) => {
    const { selectedFileType, validation } = this.state;
    const dataTypes = validation[selectedFileType];
    const keyNames = Object.keys(dataTypes);
    if (Object.keys(item).length !== keyNames.length) {
      this.setState({
        error:
          "Invalid length of uploaded data. Below data are invalid. Please Upload a valid file format",
      });
      return false;
    }
    /*if(Object.keys(item).filter(key => (keyNames.indexOf(key) === -1)).length){
      this.setState({
        error: "Invalid header of data uploaded. Below data are invalid. Please Upload a valid file formate"
      })
      return false
    }
    if(Object.keys(item).filter(key => (typeof item[key] !== dataTypes[key])).length){
      this.setState({
        error: "Invalid datatype of data uploaded.Below data are invalid. Please Upload a valid file formate"
      })
      return false
    }*/
    return true;
  };

  processData() {
    var ToDataValues = localStorage.getItem("ToDataVal");
    var setToData;

    console.log(ToDataValues);

    if (localStorage.getItem("ToDataVal") === "bin") {
      setToData = this.state.BinId;
    } else {
      setToData = localStorage.getItem("ToDataVal");
    }

    const payload = {
      skuId: this.state.sku_id,
      location: this.state.selectedLocation,
      from: localStorage.getItem("FromDataVal"),
      to: setToData,
      qty: this.state.typeaheadText,
      reasonId: localStorage.getItem("ReasonValues"),
      remarks: this.state.typeaheadText2,
    };

    API.post("/stock/submitStock/v1/", { param: payload })
      .then((response) => {
        console.log(response);

        if (response.data.success === true) {
          this.setState({
            modal: false,
            Successmodal: true,
          });

          this.fetchStockData();
        }
      })
      .catch(function (error) {});
  }

  exportToCSV = (csvData, fileName) => {
    let today_date = new Date();
    let date = today_date.getDate();
    let month = today_date.getMonth() + 1;
    let year = today_date.getFullYear();

    if (parseInt(month.toString().length) == 1) {
      month = "0" + month.toString();
    }

    let today = year + "-" + month + "-" + date;
    fileName = fileName + "_" + today;

    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;

    const data = {
      columns: [
        {
          label: "Bin ID",

          field: "bin_id",
          sort: "asc",
        },

        {
          label: "Storage Type",

          field: "storage_type",
          sort: "asc",
        },

        {
          label: "Aisle",

          field: "aisle",
          sort: "asc",
        },

        {
          label: "Rack",

          field: "rack",
          sort: "asc",
        },

        {
          label: "Rack Type",

          field: "rack_type",
          sort: "asc",
        },

        {
          label: "Level",

          field: "level",
          sort: "asc",
        },

        {
          label: "BIN",

          field: "bin",
          sort: "asc",
        },

        {
          label: "Zone Name",

          field: "zone_name",
          sort: "asc",
        },

        {
          label: "Zone No.",

          field: "zone_no",
          sort: "asc",
        },
      ],

      rows: this.state.tableRows,
    };

    const baseData = {
      columns: [
        {
          label: "Base Pack Code",

          field: "base_pack_code",
        },

        {
          label: "zoneName",

          field: "zone_name",
        },

        {
          label: "zoneNumber",

          field: "zone_number",
        },
      ],

      rows: this.state.tableRowsBase,
    };

    const productData = {
      columns: [
        {
          label: "LB SKU ID",

          field: "lb_sku_id",

          width: 150,
        },

        {
          label: "PKD",

          field: "pkd",

          width: 150,
        },

        {
          label: "MRP",

          field: "mrp",

          width: 150,
        },

        {
          label: "CBU Code",

          field: "cbu_code",

          width: 150,
        },

        {
          label: "Transaction Qty",

          field: "qty",

          width: 150,
        },

        {
          label: "GRN/PTL ID",

          field: "grn_id",

          width: 150,
        },

        {
          label: "From Area",

          field: "from_area",

          width: 150,
        },

        {
          label: "From Pre Qty",

          field: "from_pre_move_count",

          width: 150,
        },

        {
          label: "From Post Qty",

          field: "from_post_move_count",

          width: 150,
        },

        {
          label: "To Area",

          field: "to_area",

          width: 150,
        },

        {
          label: "To Pre Qty",

          field: "to_pre_move_count",

          width: 150,
        },

        {
          label: "To Post Qty",

          field: "to_post_move_count",

          width: 150,
        },

        {
          label: "Status",

          field: "status",

          width: 180,
        },

        {
          label: "Date",

          field: "date",

          width: 150,
        },

        {
          label: "Employee",

          field: "employee",
          width: 150,
        },

        {
          label: "Location",

          field: "location",
          width: 150,
        },

        {
          label: "Reason",

          field: "reason",

          width: 150,
        },
      ],

      rows: this.state.tableRowsProduct,
    };

    return (
      <Col xl={12}>
        <Card>
          <CardBody style={{ display: "none" }}>
            <div className="card__title">
              <h5 className="bold-text"></h5>
            </div>
            <form className="form form--inline" onSubmit={handleSubmit}>
              <div
                className="form__form-group col-xl-5"
                style={{ display: "inline-flex" }}
              >
                <span
                  className="form__form-group-label col-xl-4"
                  style={{ display: "inline", paddingTop: 6, paddingBottom: 6 }}
                >
                  Select Master
                </span>

                <div
                  className="form__form-group-field col-xl-6"
                  style={{ display: "contents" }}
                >
                  <Field
                    name="select"
                    label="Select"
                    component={renderSelectField}
                    placeholder="Select Master"
                    value={selectedOption}
                    onChange={this.change}
                    options={[
                      { value: "bin_master", label: "Bin Master" },
                      { value: "base_pack_zone", label: "Basepack Zone" },
                      { value: "product_master", label: "Product Master" },
                    ]}
                  />
                </div>
              </div>

              <div className="form__form-group col-xl-5">
                <div className="col-xl-12">
                  <input
                    style={{ paddingTop: 8, height: 38 }}
                    name="defaultInput"
                    component="input"
                    type="file"
                    placeholder="Default Input"
                    className="fileControl"
                    id="my_file_input"
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col-xl-12">
                  <span
                    style={{ display: "none", color: "red" }}
                    className="upload_error"
                  >
                    {" "}
                    Invalid file format. Please select .xls, .xlsx, .csv file
                    format{" "}
                  </span>
                  <span
                    style={{ display: "none", color: "green", marginTop: 8 }}
                    className="upload_success"
                  >
                    {" "}
                    Valid file format{" "}
                  </span>
                </div>
              </div>

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <button
                    color="primary"
                    className="btn-sm button_enable "
                    style={{
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                    }}
                    id="button_enable"
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Submit
                  </button>
                </ButtonToolbar>
              </div>
            </form>
          </CardBody>

          {this.state.showRowDataError && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                <h4
                  style={{ color: "red", fontWeight: "bold" }}
                  className="subhead red-text"
                >
                  {" "}
                  Please upload file again.{" "}
                </h4>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>BIN ID</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.ErrorRowData.length > 0 &&
                    this.state.ErrorRowData.map((item, index) => (
                      <tr>
                        <td>{item["Bin"]}</td>
                        <td style={{ color: "red" }}> Column is missing </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showInvalidItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                {this.state.show_process_data && (
                  <h4
                    style={{ color: "red", fontWeight: "bold" }}
                    className="subhead red-text"
                  >
                    <Button
                      style={{
                        backgroundColor: "#24d6a3",
                        color: "#fff",
                        marginLeft: 12,
                      }}
                      className="modal_ok show_bin_proceed"
                      onClick={this.processData}
                    >
                      {this.state.loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Proceed
                    </Button>
                  </h4>
                )}
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>BIN ID</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.responseFailBinData.failure_response.length > 0 &&
                    this.state.responseFailBinData.failure_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.bin_address}</td>
                          <td style={{ color: "red" }}>{item.message}</td>
                        </tr>
                      )
                    )}

                  {this.state.responseSuccessBinData.success_response.length >
                    0 &&
                    this.state.responseSuccessBinData.success_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.bin_address}</td>
                          <td style={{ color: "green" }}>{item.message}</td>
                        </tr>
                      )
                    )}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showFetchBinData && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <h4 style={{ fontWeight: "bold" }} className="subhead red-text">
                  {" "}
                  BIN MASTER
                </h4>
              </div>
              <MDBDataTable striped bordered hover data={data} />
            </CardBody>
          )}

          {this.state.showRowDataErrorBase && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                <h4
                  style={{ color: "red", fontWeight: "bold" }}
                  className="subhead red-text"
                >
                  Please upload file again{" "}
                </h4>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>Base Pack Code</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.ErrorRowData.length > 0 &&
                    this.state.ErrorRowData.map((item, index) => (
                      <tr>
                        <td>{item["Basepack Code"]}</td>
                        <td style={{ color: "red" }}> Column is missing </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showInvalidBaseItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                {this.state.show_process_data && (
                  <h4
                    style={{ color: "red", fontWeight: "bold" }}
                    className="subhead red-text"
                  >
                    {" "}
                    <Button
                      style={{
                        backgroundColor: "#24d6a3",
                        color: "#fff",
                        marginLeft: 12,
                      }}
                      className="modal_ok"
                      onClick={this.processData}
                    >
                      {this.state.loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Proceed
                    </Button>{" "}
                  </h4>
                )}
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>Base Pack Code</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.responseFailBaseData.failure_response.length >
                    0 &&
                    this.state.responseFailBaseData.failure_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{ color: "red" }}>{item.message}</td>
                        </tr>
                      )
                    )}

                  {this.state.responseSuccessBaseData.success_response.length >
                    0 &&
                    this.state.responseSuccessBaseData.success_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{ color: "green" }}>{item.message}</td>
                        </tr>
                      )
                    )}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showFetchBaseData && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <h4 style={{ fontWeight: "bold" }} className="subhead red-text">
                  {" "}
                  BASE PACK MASTER
                </h4>
              </div>
              <MDBDataTable striped bordered hover data={baseData} />
            </CardBody>
          )}

          {this.state.showRowDataErrorProduct && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                <h4
                  style={{ color: "red", fontWeight: "bold" }}
                  className="subhead red-text"
                >
                  {" "}
                  Please upload file again{" "}
                </h4>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>LB SKU ID</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.ErrorRowData.length > 0 &&
                    this.state.ErrorRowData.map((item, index) => (
                      <tr>
                        <td>{item["LB SKU ID"]}</td>
                        <td style={{ color: "red" }}> Column is missing </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showInvalidProductItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                {this.state.show_process_data && (
                  <h4
                    style={{ color: "red", fontWeight: "bold" }}
                    className="subhead red-text"
                  >
                    <Button
                      style={{
                        backgroundColor: "#24d6a3",
                        color: "#fff",
                        marginLeft: 12,
                      }}
                      className="modal_ok"
                      onClick={this.processData}
                    >
                      {this.state.loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Proceed
                    </Button>
                  </h4>
                )}
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>LB SKU ID</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.responseFailProductData.failure_response.length >
                    0 &&
                    this.state.responseFailProductData.failure_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.lb_sku_id}</td>
                          <td style={{ color: "red" }}>{item.message}</td>
                        </tr>
                      )
                    )}

                  {this.state.responseSuccessProductData.success_response
                    .length > 0 &&
                    this.state.responseSuccessProductData.success_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.lb_sku_id}</td>
                          <td style={{ color: "green" }}>{item.message}</td>
                        </tr>
                      )
                    )}
                </tbody>
              </Table>
            </CardBody>
          )}

          <CardBody style={{ marginTop: 20 }}>
            <form className="form form--inline" onSubmit={handleSubmit}>
              <div
                className="form__form-group col-xl-2"
                style={{ display: "inline-flex", marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                  <input
                    style={{ height: 38, width: "100%" }}
                    name="ledger_binaddress"
                    type="text"
                    placeholder="Bin Address"
                    id="ledger_binaddress"
                    onChange={this.ledgerLbskuIDChange}
                  />
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ display: "inline-flex", marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                  <input
                    style={{ height: 38, width: "100%" }}
                    name="ledger_lbskuid"
                    type="text"
                    placeholder="LBSKUID"
                    id="ledger_lbskuid"
                    onChange={this.ledgerLbskuIDChange}
                  />
                </div>
              </div>
              <div
                className="form__form-group col-xl-2"
                style={{ display: "inline-flex", marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                  <input
                    style={{ height: 38, width: "100%" }}
                    name="ledger_cbucode"
                    type="text"
                    placeholder="CBU Code"
                    id="ledger_cbucode"
                    onChange={this.ledgerLbskuIDChange}
                  />
                </div>
              </div>
              <div
                className="form__form-group col-xl-2"
                style={{
                  display: "inline-block",
                  width: "100%",
                  marginBottom: "0px",
                }}
              >
                <DatePicker
                  selected={this.state.ledger_fromdate}
                  onChange={this.ledgerFromDateChange}
                  className="ledger_fromdate"
                  placeholderText="From Date"
                  format="yyyy-MM-dd"
                />
              </div>
              <div
                className="form__form-group col-xl-2"
                style={{
                  display: "inline-block",
                  width: "100%",
                  marginBottom: "0px",
                }}
              >
                <DatePicker
                  selected={this.state.ledger_todate}
                  onChange={this.ledgerToDateChange}
                  className="ledger_todate"
                  placeholderText="To Date"
                />
              </div>

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <button
                    color="primary"
                    className="btn-sm button_enable "
                    style={{
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                    }}
                    id="button_enable"
                    onClick={this.handleSearchClick}
                  >
                    Search
                  </button>
                </ButtonToolbar>
              </div>
            </form>
          </CardBody>

          {this.state.showHistoryData && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <h4
                  style={{
                    fontWeight: "bold",
                    width: "80%",
                    paddingTop: 10,
                    float: "left",
                  }}
                  className="subhead red-text"
                >
                  History
                </h4>
                <Button
                  style={{
                    marginBottom: 0,
                    paddingTop: 5,
                    paddingBottom: 5,
                    paddingLeft: 26,
                    paddingRight: 26,
                    fontWeight: "bold",
                  }}
                  variant="warning"
                  onClick={(e) =>
                    this.exportToCSV(this.state.postsProduct, "ProductLedger")
                  }
                >
                  Download Excel
                </Button>
              </div>
              <MDBDataTable scrollX striped bordered hover data={productData} />
            </CardBody>
          )}
        </Card>

        <Modal
          isOpen={modal}
          toggle={this.toggle}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Stock Movement
            </h4>
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15, fontWeight: "bold" }}
              onClick={this.toggle}
            />
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 16 }}>
            <div style={{ width: "100%", height: 75 }}>
              <div
                style={{
                  width: "50%",
                  float: "left",
                  textAlign: "left",
                  marginBottom: 10,
                }}
              >
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> LB SKU ID: </span>{" "}
                  <span> {this.state.lbskuid_val} </span>{" "}
                </span>
              </div>

              <div
                style={{
                  width: "50%",
                  float: "left",
                  textAlign: "right",
                  marginBottom: 10,
                }}
              >
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> PKD: </span>{" "}
                  <span> {this.state.pkd_val} </span>{" "}
                </span>
              </div>

              <div style={{ width: "50%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> Product: </span>{" "}
                  <span> {this.state.product} </span>{" "}
                </span>
              </div>

              <div style={{ width: "50%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}>
                    {" "}
                    Current Stock Count:{" "}
                  </span>{" "}
                  <span> {this.state.stock_val} </span>{" "}
                </span>
              </div>
            </div>

            <div
              className="stockContainer"
              style={{
                width: "100%",
                height: 320,
                paddingTop: 15,
                paddingLeft: 22,
                paddingRight: 8,
              }}
            >
              <div
                style={{
                  width: "25%",
                  float: "left",
                  textAlign: "left",
                  marginTop: 4,
                  marginBottom: 12,
                }}
              >
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> From Zone/Bin </span>{" "}
                </span>
              </div>

              <div
                style={{
                  width: "75%",
                  float: "left",
                  textAlign: "left",
                  marginBottom: 12,
                }}
              >
                <select
                  className="form-control grn_line_no"
                  style={{ fontSize: 13, width: "50%" }}
                  value={this.state.FromValue}
                  onChange={this.handleChangeFrom}
                >
                  <option value="0" dis>
                    Select Zone/Bin
                  </option>
                  {this.state.arr_data_val &&
                    this.state.arr_data_val.length > 0 &&
                    this.state.arr_data_val.map((schema) => {
                      return (
                        <option value={schema.value}> {schema.label}</option>
                      );
                    })}

                  {this.state.binData &&
                    this.state.binData.length > 0 &&
                    this.state.binData.map((schema) => {
                      return (
                        <option value={schema.binId}>
                          {" "}
                          {schema.binAddress}
                        </option>
                      );
                    })}
                </select>
              </div>

              {this.state.showToZone && (
                <div
                  style={{
                    width: "25%",
                    float: "left",
                    textAlign: "left",
                    marginTop: 4,
                    marginBottom: 12,
                  }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span style={{ fontWeight: "bold" }}> To Zone/Bin </span>{" "}
                  </span>
                </div>
              )}

              {this.state.showToZone && (
                <div
                  style={{
                    width: "75%",
                    float: "left",
                    textAlign: "left",
                    marginBottom: 12,
                  }}
                >
                  <select
                    className="form-control grn_line_no"
                    style={{ fontSize: 13, width: "50%" }}
                    value={this.state.value}
                    onChange={this.handleChangeValues}
                  >
                    <option value="0">Select Zone/Bin</option>
                    {this.state.schemas &&
                      this.state.schemas.length > 0 &&
                      this.state.schemas.map((schema) => {
                        return <option value={schema}> {schema}</option>;
                      })}
                  </select>
                </div>
              )}

              {this.state.showBinAddress && (
                <div
                  style={{
                    width: "25%",
                    float: "left",
                    textAlign: "left",
                    marginTop: 4,
                    marginBottom: 12,
                  }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span style={{ fontWeight: "bold" }}>
                      {" "}
                      Enter Bin Address{" "}
                    </span>{" "}
                  </span>
                </div>
              )}

              {this.state.showBinAddress && (
                <div
                  style={{
                    width: "75%",
                    float: "left",
                    textAlign: "left",
                    marginBottom: 12,
                  }}
                >
                  <div
                    className="search-container"
                    style={{ alignItem: "left" }}
                  >
                    <div className="react-search-field test-class">
                      <input
                        className="react-search-field-input"
                        placeholder="Enter Bin Address"
                        type="text"
                        style={{
                          padding: 4,
                          borderRadius: 2,
                          width: "50%",
                          fontSize: 13,
                        }}
                        value={this.state.typeaheadText1}
                        onChange={this.showTypeahead1}
                      />
                    </div>

                    {this.state.showTypeahead1 && (
                      <div
                        className="suggestions-container"
                        style={{ height: 150, width: "50%" }}
                        ref={(el) => (this.typeahead = el)}
                      >
                        {this.state.zwz_search_pannel && (
                          <div
                            className="suggestions"
                            onClick={this.closeContainer}
                          >
                            {this.state.data.length > 0 &&
                              this.state.data.map((item, index) => (
                                <p
                                  key={index}
                                  onClick={() =>
                                    this.setBinId(item.binAddress, item.binId)
                                  }
                                  className="typeahead-text"
                                >
                                  {item.binAddress}{" "}
                                </p>
                              ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {this.state.showQuantity && (
                <div
                  style={{
                    width: "25%",
                    float: "left",
                    textAlign: "left",
                    marginTop: 4,
                    marginBottom: 12,
                  }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span style={{ fontWeight: "bold" }}>
                      {" "}
                      Quantity To Move{" "}
                    </span>{" "}
                  </span>
                </div>
              )}

              {this.state.showQuantity && (
                <div
                  style={{
                    width: "75%",
                    float: "left",
                    textAlign: "left",
                    marginBottom: 12,
                  }}
                >
                  <input
                    className="react-search-field-input"
                    placeholder="Quantity"
                    type="text"
                    style={{ padding: 7, borderRadius: 4, width: "50%" }}
                    value={this.state.typeaheadText}
                    onChange={this.showTypeahead}
                    onKeyPress={this.ShowotherKey}
                  />
                </div>
              )}

              {this.state.showReason && (
                <div
                  style={{
                    width: "25%",
                    float: "left",
                    textAlign: "left",
                    marginTop: 4,
                    marginBottom: 12,
                  }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span style={{ fontWeight: "bold" }}>Select Reason </span>{" "}
                  </span>
                </div>
              )}

              {this.state.showReason && (
                <div
                  style={{
                    width: "75%",
                    float: "left",
                    textAlign: "left",
                    marginBottom: 12,
                  }}
                >
                  <select
                    className="form-control grn_line_no"
                    style={{ fontSize: 13, width: "50%" }}
                    value={this.state.Reasonvalue}
                    onChange={this.handleChangeValuesReason}
                  >
                    <option value="0" dis>
                      Select Reason
                    </option>
                    {this.state.reason &&
                      this.state.reason.length > 0 &&
                      this.state.reason.map((schema) => {
                        return (
                          <option value={schema.id}>
                            {" "}
                            {schema.description}
                          </option>
                        );
                      })}

                    <option value="other" dis>
                      Other
                    </option>
                  </select>
                </div>
              )}

              {this.state.showRemarks && (
                <div
                  style={{
                    width: "25%",
                    float: "left",
                    textAlign: "left",
                    marginTop: 4,
                  }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span style={{ fontWeight: "bold" }}> Remarks </span>{" "}
                  </span>
                </div>
              )}

              {this.state.showRemarks && (
                <div style={{ width: "75%", float: "left", textAlign: "left" }}>
                  <Field
                    name="textarea"
                    component="textarea"
                    type="text"
                    value={this.state.typeaheadText2}
                    onChange={this.showTypeahead2}
                    style={{ lineHeight: 2.15, width: "50%" }}
                  />
                </div>
              )}
            </div>

            <ButtonToolbar className="modal__footer">
              <Button
                style={{ backgroundColor: "#ddd", color: "rgb(72, 68, 68)" }}
                className="modal_ok"
                onClick={this.togglePressCancel}
              >
                Cancel
              </Button>

              {this.state.showSubmitBtn && (
                <Button
                  style={{
                    backgroundColor: "#24d6a3",
                    color: "#fff",
                    marginLeft: 12,
                  }}
                  className="modal_ok"
                  onClick={this.processData}
                >
                  Submit
                </Button>
              )}
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}
          style={{ maxWidth: 578 }}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleFailed}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ddd", color: "#fff" }}
              className="modal_ok"
              onClick={this.togglePressCancel}
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Successmodal} toggle={this.Successtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Successtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>Successfully Updated</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.SuccesstoggleCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
